import EventEmitter2 from "eventemitter2";

import GForm from "@components/GForm";
import windmill from "@core/windmill";
import { $ } from "@utils/dom";

class Gform extends EventEmitter2 {
  constructor(el) {
    super();

    this.el = el;
    this.gform = null;

    this._onResize = this._onResize.bind(this);
    this._updatePostTitleField = this._updatePostTitleField.bind(this);

    this.init();
  }

  init() {
    this.gform = new GForm(this.el);
    this.gform.on('resize', this._onResize);

    windmill.on('done', this._updatePostTitleField);
  }
  destroy() {
    windmill.off('done', this._updatePostTitleField);

    if (this.gform) {
      this.gform.off('resize', this._onResize);
      this.gform.destroy();
    }

    this.el = null;
    this.gform = null;

    this._onResize = null;
    this._updatePostTitleField = null;
  }

  _onResize() {
    this.emit('resize');
  }
  _updatePostTitleField() {
    if( !this.gform ) return;

    const h1 = $('h1');
    
    if( !h1 ) {
      this.gform.updatePostTitle('');
      return;
    }

    const pageTitle = h1.hasAttribute('aria-label') ? h1.getAttribute('aria-label') : h1.innerText;
    this.gform.updatePostTitle(pageTitle);
  }
}

export default Gform;
